import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Autocomplete,
  TextField,
  Divider,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import KeyboardBackspaceTwoToneIcon from "@mui/icons-material/KeyboardBackspaceTwoTone";
import { DownloadIcon } from "../../Resources/Icons/icons";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import {
  GetVehicleDetails,
  GetTP,
  PostVehicleDetails,
} from "../../Service/_index";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form } from "formik";
import moment from "moment/moment";
import "./MotorCalculation.scss";
import {
  bike,
  privateCar,
  taxi,
  bus,
  gcvG3,
  threeWheeler,
  miscellaneousVehicle,
} from "./configJson";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  calcCarAndBike,
  calcBus,
  calcThreeWheeler,
  calcmisc,
} from "./VehiclePremiumCalculator";
import { tpCcOverride } from "../Policy/OnlinePolicy/utils/prefillHandoff";
import { BorderColor } from "@mui/icons-material";
import whiteDownload from "../../Resources/Images/whiteDownload.png";
import { color } from "framer-motion";

const initialValues = {
  policyType: "",
  IDV: "",
  yearOfManufacture: "",
  zone: "",
  cc: "",
  discOnOD: "",
  accessoriesValue: "",
  noclaimBonus: "",
  zerodeprecation: "",
  PAownerDriver: "",
  PAunnamedPass: "",
  TPPDRestrict: "",
  seatingCapacity: "",
  LLtoPaidDriver: "",
  premiumYear: "",
  imt23: true,
  cooliesOrCleaner: "",
  GVW: "",
  quoteId: "",
};

const Calculations = (props) => {
  const { setOpen, title, resultValue, selectedVehicle, prefill } = props;
  let formRef = useRef(null);
  const [openBox, setOpenBox] = useState(false);
  const [formData, setFormData] = useState({
    field1: "",
    field2: "",
    field3: "",
    field4: "",
  });
  // const [open, setOpen] = useState(false);
  // const [inputData, setInputData] = useState({});

  const handleOpen = () => setOpenBox(true);
  const handleClose = () => setOpenBox(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [tpData, setTpData] = useState(null);
  const [isFirst, setIsfirst] = useState(true);
  const [inputData, setInputData] = useState({
    formId: selectedVehicle.id,
    seatingCapacity: null,
    iDV: 0,
    policyType: "Full",
    zone: "A",

    // Figures carried over from a policy's Premium Calculation dialog, when
    // this page was opened from there. Merged into the INITIAL state rather
    // than pushed in by an effect, so the fields are filled on first paint and
    // nothing the user then types is overwritten behind them.
    //
    // The keys already match: that dialog builds them with the same
    // label-to-key rule this form uses (getItemKey — "IDV" -> iDV, "CC" -> cC).
    ...(prefill?.inputData || {}),
  });
  console.log("inputData", inputData);

  const BoxStyle = {
    display: "flex",
    width: "100%",
    flexDirection: { xs: "column", md: "row" },
    backgroundColor: "#F5F7F9",
    padding: "10px 20px 0px",
    borderRadius: "10px 10px 0px 0px",
    border: "solid #EAECF0",
    borderWidth: "1px 1px 0px 1px",
  };
  const BoxStyle1 = {
    width: "100%",
    flexDirection: "row",
    backgroundColor: "#F5F7F9",
    padding: "0px 20px",
    borderRadius: "0px 0px 10px 10px",
    border: "solid #EAECF0",
    borderWidth: "0 1px 1px 1px",
  };
  const rowStyleLabel = {
    width: "100%",
    height: "100%",
    fontFamily: "inter",
    fontSize: "13px",
    color: "#2b2d42",
    fontWeight: "400",
    textAlign: "center ",
  };
  const rowStyleLabel1 = {
    width: "100%",
    height: "100%",
    fontFamily: "inter",
    fontSize: "16px",
    color: "#000000ff",
    fontWeight: "600",
    textAlign: "center ",
  };
  const rowStyleValue = {
    fontFamily: "inter",
    fontSize: "14px",
    color: "#2b2d42",
    fontWeight: "500",
    textAlign: "center ",
  };
  const rowStyleValue1 = {
    fontFamily: "inter",
    fontSize: "16px",
    color: "#000000ff",
    fontWeight: "600",
    textAlign: "center ",
  };

  const [viewData, setViewData] = useState({});

  const formatTwo = (value) => {
    const num = Number(value ?? 0);
    return Number.isNaN(num) ? "0.00" : num.toFixed(2);
  };

  console.log("kfnsnd", viewData)
  const handleDownload = () => {
    console.log("inputDdddata", inputData);
    if (
      inputData.policyType &&
      ((inputData.policyType == "Full" && inputData.zone) ||
        inputData.policyType != "Full")
    ) {
      var doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.width;

      const leftMargin = 14;
      const rightMargin = 14;
      let yPosition = 20;

      doc.setFont("Inter", "bold");
      doc.setFontSize(12);

      doc.text(inputData?.Company || "", leftMargin, 10);
      doc.setFontSize(10);
      doc.text(inputData?.CustomerName || "", leftMargin, 16);
      yPosition = 20;
      doc.setDrawColor(192, 192, 192);
      doc.setFontSize(10);
      doc.text(title || "", pageWidth - rightMargin - doc.getTextWidth(title || ""), 10);
      doc.text(
        `Vehicle Number : ${inputData?.VehicleNumber || ""}`,
        pageWidth -
        rightMargin -
        doc.getTextWidth(
          `Vehicle Number : ${inputData?.VehicleNumber || ""}`
        ),
        16
      );
      doc.text(
        `Make Model : ${inputData?.MakeModel || ""}`,
        pageWidth -
        rightMargin -
        doc.getTextWidth(`Make Model : ${inputData?.MakeModel || ""}`),
        22
      );

      yPosition += 10;
      const tableStartY = yPosition;
      const tableWidth = pageWidth - leftMargin - rightMargin;
      const rowHeight = 10;
      doc.rect(leftMargin, tableStartY, tableWidth * 0.5, rowHeight);
      doc.text(
        "IDV",
        leftMargin + (tableWidth * 0.5 - doc.getTextWidth("IDV")) / 2,
        tableStartY + 6
      );
      doc.rect(
        leftMargin + tableWidth * 0.5,
        tableStartY,
        tableWidth * 0.5,
        rowHeight
      );
      doc.text(
        (viewData?.iDV || 0).toString(),
        leftMargin +
        tableWidth * 0.5 +
        (tableWidth * 0.5 - doc.getTextWidth((viewData?.iDV || 0).toString())) / 2,
        tableStartY + 6
      );

      doc.setFont("helvetica", "normal");
      yPosition = tableStartY + rowHeight;
      const box1Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box1Width, rowHeight);
      doc.text("Year of Manufacture", leftMargin + 2, yPosition + 6);
      doc.rect(leftMargin + box1Width, yPosition, box1Width, rowHeight);
      doc.text(
        (viewData?.yearOfManufacture || "-").toString(),
        leftMargin + box1Width + 2,
        yPosition + 6
      );
      const box2X = leftMargin + box1Width * 2;
      doc.rect(box2X, yPosition, box1Width, rowHeight);
      doc.text("Zone", box2X + 2, yPosition + 6);
      const box3X = leftMargin + box1Width * 3;
      doc.rect(box3X, yPosition, box1Width, rowHeight);
      doc.text((viewData?.zone || "-").toString(), box3X + 2, yPosition + 6);

      yPosition = yPosition + rowHeight;
      const box2Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box2Width, rowHeight);
      doc.text("LPG Kit-A", leftMargin + 2, yPosition + 6);
      doc.rect(leftMargin + box2Width, yPosition, box2Width, rowHeight);
      doc.text(
        (viewData?.lPGKit_A?.toFixed(2) || 0).toString(),
        leftMargin + box2Width + 2,
        yPosition + 6
      );
      const box22X = leftMargin + box2Width * 2;
      doc.rect(box22X, yPosition, box2Width, rowHeight);
      doc.text("Liability Premium", box22X + 2, yPosition + 6);
      const box23X = leftMargin + box2Width * 3;
      doc.rect(box23X, yPosition, box2Width, rowHeight);
      doc.text((viewData?.LP || "-").toString(), box23X + 2, yPosition + 6);

      yPosition = yPosition + rowHeight;
      const box3Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box3Width, rowHeight);
      doc.text("OD Premium", leftMargin + 2, yPosition + 6);
      doc.rect(leftMargin + box3Width, yPosition, box3Width, rowHeight);
      doc.text(
        (viewData?.OdPremium || 0).toString(),
        leftMargin + box3Width + 2,
        yPosition + 6
      );
      const box32X = leftMargin + box3Width * 2;
      doc.rect(box32X, yPosition, box3Width, rowHeight);
      doc.text("LPG KIT - B", box32X + 2, yPosition + 6);
      const box33X = leftMargin + box3Width * 3;
      doc.rect(box33X, yPosition, box3Width, rowHeight);
      doc.text(
        (viewData?.lPGKit_B?.toFixed(2) || 0).toString(),
        box33X + 2,
        yPosition + 6
      );

      yPosition = yPosition + rowHeight;
      const box4Width = tableWidth * 0.25;
      const wrappedText = doc.splitTextToSize(
        "Discount on OD Premium",
        box4Width - 4
      );
      doc.rect(leftMargin, yPosition, box4Width, rowHeight);
      doc.text(wrappedText, leftMargin + 2, yPosition + 2, {
        align: "left",
        baseline: "top",
      });
      doc.rect(
        leftMargin + box4Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.discountonODPremium || 0).toString(),
        leftMargin + box4Width + 2,
        yPosition + 6
      );
      doc.rect(
        leftMargin + box4Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.discountonODPremiumValue || 0).toString(),
        leftMargin + box4Width + 2 + (tableWidth * 0.25) / 2,
        yPosition + 6
      );
      const box42X = leftMargin + box4Width * 2;
      doc.rect(box42X, yPosition, box4Width, rowHeight);
      doc.text("PA to Owner Driver", box42X + 2, yPosition + 6);
      const box43X = leftMargin + box4Width * 3;
      doc.rect(box43X, yPosition, box4Width, rowHeight);
      doc.text(
        (viewData?.pAOwnerDriver || 0).toString(),
        box43X + 2,
        yPosition + 6
      );

      yPosition = yPosition + rowHeight;
      const box5Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box5Width, rowHeight + 1);
      doc.text(
        doc.splitTextToSize("Basic Od Premium After Discount", box4Width - 4),
        leftMargin + 2,
        yPosition + 2,
        { align: "left", baseline: "top" }
      );
      doc.rect(leftMargin + box5Width, yPosition, box5Width, rowHeight + 1);
      doc.text(
        (viewData?.basicODPremiumAfterDiscount || 0).toString(),
        leftMargin + box5Width + 2,
        yPosition + 6
      );
      const box52X = leftMargin + box5Width * 2;
      doc.rect(box52X, yPosition, box5Width, rowHeight + 1);
      doc.text("LL to Paid Driver", box52X + 2, yPosition + 6);
      const box53X = leftMargin + box5Width * 3;
      doc.rect(box53X, yPosition, box5Width, rowHeight + 1);
      doc.text(
        (viewData?.lLtoPaidDriver || 0).toString(),
        box53X + 2,
        yPosition + 6
      );

      yPosition = yPosition + rowHeight + 1;
      const box6Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box6Width, rowHeight);
      doc.text("Accessories Value", leftMargin + 2, yPosition + 6);
      doc.rect(
        leftMargin + box6Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.accessories || 0).toString(),
        leftMargin + box6Width + 2,
        yPosition + 6
      );

      doc.rect(
        leftMargin + box6Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.accessories || 0).toString(),
        leftMargin + box6Width + 2 + (tableWidth * 0.25) / 2,
        yPosition + 6
      );

      const box62X = leftMargin + box6Width * 2;
      if (
        inputData.formId === 1 ||
        inputData.formId === 7 ||
        inputData.formId === 8 ||
        inputData.formId === 9 ||
        inputData.formId === 10 ||
        inputData.formId === !6
      ) {
        doc.rect(box62X, yPosition, box6Width, rowHeight);
        doc.text("CC", box62X + 2, yPosition + 6);
        const box63X = leftMargin + box6Width * 3;
        doc.rect(box63X, yPosition, box6Width, rowHeight);
        doc.text((viewData?.cc || 0).toString(), box63X + 2, yPosition + 6);
      } else {
        doc.rect(box62X, yPosition, tableWidth * 0.5, rowHeight);
      }

      yPosition = yPosition + rowHeight;
      const box7Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box7Width, rowHeight);
      doc.text("Total Basic Premium", leftMargin + 2, yPosition + 6);
      doc.rect(leftMargin + box7Width, yPosition, box7Width, rowHeight);
      doc.text(
        (viewData?.totalBasicPremium || 0).toString(),
        leftMargin + box7Width + 2,
        yPosition + 6
      );
      const box72X = leftMargin + box7Width * 2;

      if (
        inputData.formId === 6 ||
        inputData.formId === 7 ||
        inputData.formId === 8 ||
        inputData.formId === 9 ||
        inputData.formId === 10
      ) {
        doc.rect(box72X, yPosition, box7Width, rowHeight);
        doc.text("LL to Passengers", box72X + 2, yPosition + 6);
        const box73X = leftMargin + box7Width * 3;
        doc.rect(box73X, yPosition, box7Width, rowHeight);
        doc.text(
          (viewData?.llToPassengers || 0).toString(),
          box73X + 2,
          yPosition + 6
        );
      } else {
        doc.rect(box72X, yPosition, tableWidth * 0.5, rowHeight);
      }

      yPosition = yPosition + rowHeight;
      const box8Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box8Width, rowHeight);
      doc.text("No Claim Bonus", leftMargin + 2, yPosition + 6);

      doc.rect(
        leftMargin + box8Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.noClaimBonus || 0).toString(),
        leftMargin + box8Width + 2,
        yPosition + 6
      );

      doc.rect(
        leftMargin + box8Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.noClaimBonusValue || 0).toString(),
        leftMargin + box8Width + 2 + (tableWidth * 0.25) / 2,
        yPosition + 6
      );

      const box82X = leftMargin + box8Width * 2;

      if (inputData.formId) {
        doc.rect(box82X, yPosition, box8Width, rowHeight);
        doc.text("PA to Unnamed  Passenger", box82X + 2, yPosition + 6);
        const box83X = leftMargin + box8Width * 3;
        doc.rect(box83X, yPosition, box8Width, rowHeight);
        doc.text(
          (viewData?.pAUnnamedPassenger || 0).toString(),
          box83X + 2,
          yPosition + 6
        );
      } else {
        doc.rect(box82X, yPosition, tableWidth * 0.5, rowHeight);
      }

      yPosition = yPosition + rowHeight;
      const box9Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box9Width, rowHeight + 1);
      doc.text(
        doc.splitTextToSize("Net Own Damage Premium", box9Width - 4),
        leftMargin + 2,
        yPosition + 2,
        { align: "left", baseline: "top" }
      );
      doc.rect(leftMargin + box9Width, yPosition, box9Width, rowHeight + 1);
      doc.text(
        (viewData?.netOwnDamage || 0).toString(),
        leftMargin + box9Width + 2,
        yPosition + 6
      );
      const box92X = leftMargin + box9Width * 2;
      if (
        inputData.formId === !6 ||
        inputData.formId === 8 ||
        inputData.formId === 9
      ) {
        doc.rect(box92X, yPosition, box9Width, rowHeight + 1);
        doc.text("TPPD Restrict", box92X + 2, yPosition + 6);
        const box93X = leftMargin + box9Width * 3;
        doc.rect(box93X, yPosition, box9Width, rowHeight + 1);
        doc.text((viewData?.tppd || 0).toString(), box93X + 2, yPosition + 6);
      } else {
        doc.rect(box92X, yPosition, tableWidth * 0.5, rowHeight + 1);
      }

      yPosition = yPosition + rowHeight + 1;
      const box10Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box10Width, rowHeight);
      doc.text(
        doc.splitTextToSize("Zero Dep Premium", box10Width - 4),
        leftMargin + 2,
        yPosition + 2,
        { align: "left", baseline: "top" }
      );
      doc.rect(
        leftMargin + box10Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.zeroDepPremium || 0).toString(),
        leftMargin + box10Width + 2,
        yPosition + 6
      );

      doc.rect(
        leftMargin + box10Width,
        yPosition,
        (tableWidth * 0.25) / 2,
        rowHeight
      );
      doc.text(
        (viewData?.zeroDepPremiumValue || 0).toString(),
        leftMargin + box10Width + 2 + (tableWidth * 0.25) / 2,
        yPosition + 6
      );

      const box102X = leftMargin + box10Width * 2;
      if (
        inputData.formId === !6 ||
        inputData.formId === 8 ||
        inputData.formId === 9
      ) {
        doc.rect(box102X, yPosition, box10Width, rowHeight);
        doc.text("Coolies / Cleaner", box102X + 2, yPosition + 6);
        const box103X = leftMargin + box10Width * 3;
        doc.rect(box103X, yPosition, box10Width, rowHeight);
        doc.text(
          (viewData?.CooliesAndCleaner || 0).toString(),
          box103X + 2,
          yPosition + 6
        );
      } else {
        doc.rect(box102X, yPosition, tableWidth * 0.5, rowHeight);
      }

      if (
        inputData.formId === 6 ||
        inputData.formId === 7 ||
        inputData.formId === 8 ||
        inputData.formId === 9
      ) {
        yPosition = yPosition + rowHeight;
        const box11Width = tableWidth * 0.25;
        doc.rect(leftMargin, yPosition, box11Width, rowHeight);
        doc.text(
          doc.splitTextToSize("vehicle Basic Rate", box11Width - 4),
          leftMargin + 2,
          yPosition + 2,
          { align: "left", baseline: "top" }
        );
        doc.rect(leftMargin + box11Width, yPosition, box11Width, rowHeight);
        doc.text(
          `${(viewData?.vehiclebaseRate || 0).toString()} - ${(viewData?.vehiclebaseRateValue || 0).toString()}`,
          leftMargin + box11Width + 2,
          yPosition + 6
        );
        const box112X = leftMargin + box11Width * 2;
        doc.rect(box112X, yPosition, tableWidth * 0.5, rowHeight);
      }

      if (
        inputData.formId === 6 ||
        inputData.formId === 7 ||
        inputData.formId === 10
      ) {
        yPosition = yPosition + rowHeight;
        const box12Width = tableWidth * 0.25;
        doc.rect(leftMargin, yPosition, box12Width, rowHeight);
        doc.text("Seating Capacity", leftMargin + 2, yPosition + 2, {
          align: "left",
          baseline: "top",
        });
        doc.rect(leftMargin + box12Width, yPosition, box12Width, rowHeight);
        doc.text(
          `${(viewData?.seatingCapacityAmount || 0).toString()} - ${(
            viewData?.seatingCapacityvalue || 0
          ).toString()}`,
          leftMargin + box12Width + 2,
          yPosition + 6
        );
        const box122X = leftMargin + box12Width * 2;
        doc.rect(box122X, yPosition, tableWidth * 0.5, rowHeight);
      }

      if (
        inputData.formId === 6 ||
        inputData.formId === 7 ||
        inputData.formId === 8 ||
        inputData.formId === 9 ||
        inputData.formId === 10
      ) {
        yPosition = yPosition + rowHeight;
        const box13Width = tableWidth * 0.25;
        doc.rect(leftMargin, yPosition, box13Width, rowHeight);
        doc.text("Additional GVW", leftMargin + 2, yPosition + 2, {
          align: "left",
          baseline: "top",
        });
        doc.rect(leftMargin + box13Width, yPosition, box13Width, rowHeight);
        doc.text(
          (viewData?.additionalGVW || 0).toString(),
          leftMargin + box13Width + 2,
          yPosition + 6
        );
        const box132X = leftMargin + box13Width * 2;
        doc.rect(box132X, yPosition, tableWidth * 0.5, rowHeight);
      }

      if (
        inputData.formId === 6 ||
        inputData.formId === 7 ||
        inputData.formId === 8 ||
        inputData.formId === 9 ||
        inputData.formId === 10
      ) {
        yPosition = yPosition + rowHeight;
        const box14Width = tableWidth * 0.25;
        doc.rect(leftMargin, yPosition, box14Width, rowHeight);
        doc.text("IMT 23", leftMargin + 2, yPosition + 2, {
          align: "left",
          baseline: "top",
        });
        doc.rect(leftMargin + box14Width, yPosition, box14Width, rowHeight);
        doc.text(
          `${(viewData?.imt23 || 0).toString()} - ${(
            viewData?.imt23Value || 0
          ).toString()}`,
          leftMargin + box14Width + 2,
          yPosition + 6
        );
        const box142X = leftMargin + box14Width * 2;
        doc.rect(box142X, yPosition, tableWidth * 0.5, rowHeight);
      }

      yPosition = yPosition + rowHeight;
      const box15Width = tableWidth * 0.25;
      doc.rect(leftMargin, yPosition, box15Width, rowHeight);
      doc.text("Total A [Od Premium]", leftMargin + 2, yPosition + 2, {
        align: "left",
        baseline: "top",
      });
      doc.rect(leftMargin + box15Width, yPosition, box15Width, rowHeight);
      doc.text(
        (viewData?.totalAodPremium?.toFixed(2) || 0).toString(),
        leftMargin + box15Width + 2,
        yPosition + 6
      );
      const box152X = leftMargin + box15Width * 2;
      doc.rect(box152X, yPosition, box15Width, rowHeight);
      doc.text("Total B [Od Premium]", box152X + 2, yPosition + 6);
      const box153X = leftMargin + box15Width * 3;
      doc.rect(box153X, yPosition, box15Width, rowHeight);
      doc.text(
        (viewData?.totalBodPremium || 0).toString(),
        box153X + 2,
        yPosition + 6
      );

      doc.setFont("Inter", "bold");

      yPosition = yPosition + rowHeight;
      doc.rect(leftMargin, yPosition, tableWidth * 0.5, rowHeight);
      doc.text(
        "Net Premium [A + B]",
        leftMargin +
        (tableWidth * 0.5 - doc.getTextWidth("Net Premium [A + B]")) / 2,
        yPosition + 6
      );
      doc.rect(
        leftMargin + tableWidth * 0.5,
        yPosition,
        tableWidth * 0.5,
        rowHeight
      );
      doc.text(
        (viewData?.netPremiumAB || 0).toString(),
        leftMargin +
        tableWidth * 0.5 +
        (tableWidth * 0.5 -
          doc.getTextWidth((viewData?.netPremiumAB || 0).toString())) /
        2,
        yPosition + 6
      );

      yPosition = yPosition + rowHeight;
      doc.rect(leftMargin, yPosition, tableWidth * 0.5, rowHeight);
      doc.text(
        "Gst@18%",
        leftMargin + (tableWidth * 0.5 - doc.getTextWidth("Gst@18%")) / 2,
        yPosition + 6
      );
      doc.rect(
        leftMargin + tableWidth * 0.5,
        yPosition,
        tableWidth * 0.5,
        rowHeight
      );
      doc.text(
        (viewData?.tax || 0).toString(),
        leftMargin +
        tableWidth * 0.5 +
        (tableWidth * 0.5 - doc.getTextWidth((viewData?.tax || 0).toString())) / 2,
        yPosition + 6
      );

      doc.setTextColor(0, 0, 255);
      yPosition = yPosition + rowHeight;
      doc.rect(leftMargin, yPosition, tableWidth * 0.5, rowHeight);
      doc.text(
        "Final Premium",
        leftMargin + (tableWidth * 0.5 - doc.getTextWidth("Final Premium")) / 2,
        yPosition + 6
      );
      doc.rect(
        leftMargin + tableWidth * 0.5,
        yPosition,
        tableWidth * 0.5,
        rowHeight
      );
      doc.text(
        (viewData?.finalPremium || 0).toString(),
        leftMargin +
        tableWidth * 0.5 +
        (tableWidth * 0.5 -
          doc.getTextWidth((viewData?.finalPremium || 0).toString())) /
        2,
        yPosition + 6
      );

      yPosition = yPosition + rowHeight;
      doc.setFont("Inter", "bold");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(14);
      doc.text("Documents Required :-", leftMargin, yPosition + 14);

      yPosition = yPosition + rowHeight;
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 255);
      doc.setFontSize(10);
      doc.text(
        "1.Previous Policy Copy   2.RC Copy",
        leftMargin,
        yPosition + 14
      );

      yPosition = yPosition + rowHeight;
      doc.setFont("helvetica", "bold");
      doc.setTextColor(255, 0, 0);
      doc.setFontSize(12);
      doc.text(
        "Note : In case of any claim , NCB will be revised and hence Quotation is Subject to Change",
        leftMargin,
        yPosition + 14
      );
      doc.save(`${title}.pdf`);
    } else {
      ToastError("Enter Mantatory fileds");
    }
  };

  const [inputs, setInputs] = useState([]);
  console.log("inputstshshs", inputs)
  const onSubmit = () => { };

  const getItemKey = (data) => {
    return data.charAt(0).toLowerCase() + data.slice(1);
  };

  React.useEffect(() => {
    GetVehicleDetails(selectedVehicle.id).then((res) => {
      setInputs(res.data);
    });
  }, [selectedVehicle]);

  React.useEffect(() => {
    GetTP().then((res) => {
      setTpData(res?.data);
    });
  }, []);

  const currentYear = new moment().year();
  const handleCalcFunction = async () => {
    const cc = Number(inputData.cC || 0);
    console.log("sdbbnm", cc)
    if (selectedVehicle.id === 1) {
      inputData.vehicle = "Two Wheeler";
      inputData.year = 1;
      let ageofvehicle = currentYear - inputData.yearOfManufacture;
      let baseRateQuery =
        cc <= 75 && cc >= 0
          ? "<75"
          : cc <= 150 && cc >= 75
            ? ">75"
            : cc <= 350 && cc > 150
              ? "<350"
              : ">350";
      console.log("inputDatainputDatainputData", inputData)
      let zoneData =
        ageofvehicle <= 5
          ? bike?.lessThenFiveYears
          : ageofvehicle <= 10 && ageofvehicle > 5
            ? bike?.lessThenTenYears
            : bike?.greaterThenTenYears;
      var tp = tpData?.twoWheeler?.oneYearTp;
      var tpvalue =
        cc <= 75 && cc >= 0
          ? tp?.lessthan75
          : cc <= 150 && cc >= 75
            ? tp?.lessthan150
            : cc <= 350 && cc > 150
              ? tp?.lessthan350
              : tp?.greaterthan350;
      var tp = {
        TP: tpvalue,
      };
      console.log("dddsdfaefaad", tp)
      console.log("dddsdfaefaad", tpvalue)
      console.log("dddsdfaefaad", tpData)
      console.log("sdbbn", cc)
      var data = await calcCarAndBike(
        inputData,
        zoneData,
        bike,
        baseRateQuery,
        tp
      );
    } else if (selectedVehicle.id === 2) {
      let ageofvehicle = 0;
      inputData.vehicle = "New Two Wheeler";
      console.log("linpuitsdsd", inputData)
      let baseRateQuery =
        cc <= 75 && cc >= 0
          ? "<75"
          : cc <= 150 && cc >= 75
            ? ">75"
            : cc <= 350 && cc > 150
              ? "<350"
              : ">350";
      let zoneData =
        ageofvehicle <= 5
          ? bike?.lessThenFiveYears
          : ageofvehicle <= 10 && ageofvehicle > 5
            ? bike?.lessThenTenYears
            : bike?.greaterThenTenYears;
      var tp = tpData?.twoWheeler?.fiveYearTp;
      console.log("fjsjdnded", tp)
      // Opened from a policy sold by two insurers: third party follows the TP
      // insurer's own vehicle, own damage (the band above) the CC in the form.
      const tpCc = tpCcOverride(prefill, inputData.cC) ?? cc;
      var tpvalue =
        tpCc <= 75 && tpCc >= 0
          ? tp?.lessthan75
          : tpCc <= 150 && tpCc >= 75
            ? tp?.lessthan150
            : tpCc <= 350 && tpCc > 150
              ? tp?.lessthan350
              : tp?.greaterthan350;
      var tp = {
        TP: tpvalue,
      };
      var data = await calcCarAndBike(
        inputData,
        zoneData,
        bike,
        baseRateQuery,
        tp
      );
      console.log("kndejkwnfkejnewke", tp)
    } else if (selectedVehicle.id === 3) {
      inputData.vehicle = "Private Car";
      inputData.year = 1;
      const ageofvehicle = currentYear - inputData.yearOfManufacture;
      let baseRateQuery =
        cc <= 1000 ? "=1000" : cc <= 1500 && cc > 1000 ? "<1500" : ">1500";
      let zoneData =
        ageofvehicle <= 5
          ? privateCar.lessThenFiveYears
          : ageofvehicle <= 10 && ageofvehicle > 5
            ? privateCar.lessThenTenYears
            : privateCar.greaterThenTenYears;
      var tp = tpData.privateCar?.oneYearTp;
      var tpvalue =
        cc <= 1000 && cc >= 0
          ? tp?.lessthan1000
          : cc <= 1500 && cc >= 1000
            ? tp?.lessthan1500
            : tp?.greaterthan1500;
      var tp = {
        TP: tpvalue,
      };
      var data = await calcCarAndBike(
        inputData,
        zoneData,
        privateCar,
        baseRateQuery,
        tp
      );
    } else if (selectedVehicle.id === 4) {
      inputData.vehicle = "New Private Car";
      const ageofvehicle = 0;
      let zoneData =
        ageofvehicle <= 5
          ? privateCar?.lessThenFiveYears
          : ageofvehicle <= 10 && ageofvehicle > 5
            ? privateCar?.lessThenTenYears
            : privateCar?.greaterThenTenYears;
      let baseRateQuery =
        cc <= 1000 ? "=1000" : cc <= 1500 && cc > 1000 ? "<1500" : ">1500";
      var tp = tpData?.privateCar?.threeYearTp;
      var tpvalue =
        cc <= 1000 && cc >= 0
          ? tp?.lessthan1000
          : cc <= 1500 && cc >= 1000
            ? tp?.lessthan1500
            : tp?.greaterthan1500;
      var tp = {
        TP: tpvalue,
      };
      var data = await calcCarAndBike(
        inputData,
        zoneData,
        privateCar,
        baseRateQuery,
        tp
      );
    } else if (selectedVehicle.id == 5) {
      inputData.vehicle = "Taxi";
      let ageofvehicle = currentYear - inputData?.yearOfManufacture;
      let baseRateQuery =
        cc <= 1000 ? "=1000" : cc <= 1500 && cc > 1000 ? "<1500" : ">1500";
      let zoneData =
        ageofvehicle <= 5
          ? taxi?.lessThenFiveYears
          : ageofvehicle <= 7 && ageofvehicle > 5
            ? taxi?.lessThenSevenYears
            : taxi?.greaterThenSevenYears;
      var tp = tpData?.taxi;
      var tpvalue =
        cc <= 1000 && cc >= 0
          ? tp?.lessthan1000
          : cc <= 1500 && cc >= 1000
            ? tp?.lessthan1500
            : tp?.greaterthan1500;
      var tp = tpvalue;
      var data = await calcCarAndBike(
        inputData,
        zoneData,
        taxi,
        baseRateQuery,
        tp
      );
    } else if (selectedVehicle.id === 6) {
      inputData.vehicle = "Bus";
      let ageofvehicle = currentYear - inputData.yearOfManufacture;
      let baseRateQuery =
        cc <= 1000 ? "=1000" : cc <= 1500 && cc > 1000 ? "<1500" : ">1500";
      let zoneData =
        ageofvehicle <= 5
          ? bus?.lessThenFiveYears
          : ageofvehicle <= 7 && ageofvehicle > 5
            ? bus?.lessThenSevenYears
            : bus?.greaterThenSevenYears;
      var tp = tpData?.bus;
      inputData.year = 1;
      var data = await calcBus(inputData, zoneData, bus, baseRateQuery, tp);
    } else if (selectedVehicle.id === 7) {
      inputData.vehicle = "School Bus";
      let ageofvehicle = currentYear - inputData.yearOfManufacture;
      let baseRateQuery =
        cc <= 1000 ? "=1000" : cc <= 1500 && cc > 1000 ? "<1500" : ">1500";
      let zoneData =
        ageofvehicle <= 5
          ? bus?.lessThenFiveYears
          : ageofvehicle <= 7 && ageofvehicle > 5
            ? bus?.lessThenSevenYears
            : bus?.greaterThenSevenYears;
      var tp = tpData?.schoolBus;
      inputData.year = 1;
      var data = await calcBus(inputData, zoneData, bus, baseRateQuery, tp);
    } else if (selectedVehicle.id === 8) {
      inputData.vehicle = "Three Wheeler PCV";
      let ageofvehicle = currentYear - inputData.yearOfManufacture;
      let zoneData =
        ageofvehicle <= 5
          ? threeWheeler?.pcv?.lessThenFiveYears
          : ageofvehicle <= 7 && ageofvehicle > 5
            ? threeWheeler?.pcv?.lessThenSevenYears
            : threeWheeler?.pcv?.greaterThenSevenYears;
      var tp = tpData?.threeWheelerPCV;
      var data = await calcThreeWheeler(
        inputData,
        zoneData,
        threeWheeler.pcv,
        tp
      );
    } else if (selectedVehicle.id === 9) {
      console.log("I AM WO");
      inputData.vehicle = "Goods Carrying Vehicle(3 Wheeler)";
      let ageofvehicle = currentYear - inputData.yearOfManufacture;
      let zoneData =
        ageofvehicle <= 5
          ? threeWheeler?.gcv?.lessThenFiveYears
          : ageofvehicle <= 7 && ageofvehicle > 5
            ? threeWheeler?.gcv?.lessThenSevenYears
            : threeWheeler?.gcv?.greaterThenSevenYears;
      var tp = tpData?.threeWheelerGCV;

      var data = await calcThreeWheeler(
        inputData,
        zoneData,
        threeWheeler.gcv,
        tp
      );

      console.log("sjndsjnd", data);
    } else if (selectedVehicle.id === 10) {
      inputData.vehicle = "Goods Carrying Vehicle(More Than 3 Wheeler)";
      let ageofvehicle = currentYear - inputData.yearOfManufacture;
      let baseRateQuery =
        cc <= 1000 ? "=1000" : cc <= 1500 && cc > 1000 ? "<1500" : ">1500";
      let zoneData =
        ageofvehicle <= 5
          ? gcvG3?.lessThenFiveYears
          : ageofvehicle <= 7 && ageofvehicle > 5
            ? gcvG3?.lessThenSevenYears
            : gcvG3?.greaterThenSevenYears;
      var tp = tpData?.morethanThreeWheelGCV;
      var data = await calcBus(inputData, zoneData, gcvG3, baseRateQuery, tp);
    } else if (selectedVehicle.id === 11) {
      inputData.vehicle = "Mischelleneous";
      let ageofvehicle = currentYear - inputData.yearOfManufacture;
      let baseRateQuery =
        cc <= 1000 ? "=1000" : cc <= 1500 && cc > 1000 ? "<1500" : ">1500";
      let zoneData =
        ageofvehicle <= 5
          ? miscellaneousVehicle?.lessThenFiveYears
          : ageofvehicle <= 7 && ageofvehicle > 5
            ? miscellaneousVehicle?.lessThenSevenYears
            : miscellaneousVehicle?.greaterThenSevenYears;

      var data = await calcmisc(
        inputData,
        zoneData,
        miscellaneousVehicle,
        baseRateQuery
      );
    } else {
      return {
        error: true,
        message: "Invalid Form ID",
      };
    }
    setViewData(data);
  };

  React.useEffect(() => {
    if (isFirst) {
      setIsfirst(false);
      return;
    }
    handleCalcFunction();
  }, [inputData]);

  // Opened with figures handed over from a policy's Premium Calculation dialog.
  //
  // The effect above deliberately skips its FIRST run, so a form that arrives
  // already filled shows its inputs but an empty breakdown — nothing is
  // calculated until some field is touched. Run it once here instead.
  //
  // Waits for tpData: the third-party rates come from it, it is fetched async
  // on mount, and calculating before it lands prints zeros for the very
  // premium the handoff exists to show.
  const prefillCalculated = useRef(false);
  React.useEffect(() => {
    if (!prefill?.inputData || prefillCalculated.current || !tpData) return;
    prefillCalculated.current = true;
    handleCalcFunction();
  }, [prefill, tpData]);

  // The TP vehicle's CC, while this page still shows the two-company policy it
  // was opened from (null otherwise) — see prefillHandoff.tpCcOverride.
  const policyTpCc = selectedVehicle.id === 2 ? tpCcOverride(prefill, inputData?.cC) : null;

  const SectionA = [
    {
      label: "IDV",
      values: [inputData?.iDV],
      // values: "",
      display: "flex",
    },
    {
      label: "Year of Manufacture",
      values: [
        inputData?.yearOfManufacture,
        selectedVehicle.id >= 1 && selectedVehicle.id <= 5
          ? "CC"
          : (selectedVehicle.id === 10)
            ? "GVW"
            : "",
      ],
      display: "flex",
    },
    {
      label: "Vehicle Basic Rate",
      values: [viewData?.vehiclebaseRate, viewData?.vehiclebaseRateValue],
      display: viewData?.formId !== 2 ? "flex" : "none",
    },
    [12].includes(selectedVehicle.id) && {
      label: "LPG KIT",
      values: [viewData?.lPGKit_A?.toFixed(2) || "-"],
      display: "flex",
    },
    [6, 7,].includes(selectedVehicle.id) && {
      label: "Seating Capacity",
      values: [viewData?.seatingCapacityAmount, viewData?.seatingCapacityvalue],
      display:
        viewData?.formId === 6 ||
          viewData?.formId === 7 ||
          viewData?.formId === 10
          ? "flex"
          : "none",
    },
    [10].includes(selectedVehicle.id) && {
      label: "Additional GVW",
      values: [viewData?.additionalGVW || 0, viewData?.gVW || 0],
      display:
        viewData?.formId === 6 ||
          viewData?.formId === 7 ||
          viewData?.formId === 8 ||
          viewData?.formId === 9 ||
          viewData?.formId === 10
          ? "flex"
          : "none",
    },
    [6, 7, 8, 9, 10, 11].includes(selectedVehicle.id) && {
      label: "IMT 23",
      values: [viewData?.imt23, viewData?.imt23Value || 0],
      display:
        viewData?.formId === 6 ||
          viewData?.formId === 7 ||
          viewData?.formId === 8 ||
          viewData?.formId === 9 ||
          viewData?.formId === 10
          ? "flex"
          : "none",
    },
    [6, 7, 8, 10, 11].includes(selectedVehicle.id) && {
      label: "OD Premium",
      values: [viewData?.OdPremium || 0],
      display: "flex",
    },
    [11].includes(selectedVehicle.id) && {
      label: "Over Turning",
      values: [viewData?.OdPremium, viewData?.OdPremium || 0],
      display: "flex",
    },
    {
      label: "Discount on OD Premium",
      values: [
        viewData?.discountonODPremium,
        viewData?.discountonODPremiumValue || 0,
      ],
      display: "flex",
    },
    {
      label: "Basic Od Premium After Discount",
      values: [viewData?.basicODPremiumAfterDiscount || 0],
      display: "flex",
    },
    {
      label: "Accessories Value",
      values: [viewData?.accessories, viewData?.accessoriesValue || 0],
      display: "flex",
    },
    {
      label: "Total Basic Premium",
      values: [viewData?.totalBasicPremium || 0],
      display: "flex",
    },
    [1, 3, 5, 6, 7, 8, 9, 10, 11].includes(Number(selectedVehicle?.id)) && {
      label: "No Claim Bonus",
      values: [viewData?.noClaimBonus, viewData?.noClaimBonusValue || 0],
      display: "flex",
    },
    {
      label: "Net Own Damage Premium",
      values: [viewData?.netOwnDamage || 0],
      display: "flex",
    },
    [1, 2, 3, 4, 5, 6, 7, 9, 10, 11].includes(Number(selectedVehicle?.id)) && {
      label: "Zero Dep Premium",
      values: [viewData?.zeroDepPremium, viewData?.zeroDepPremiumValue || 0],
      display: "flex",
    },
    {
      label: "Total A [Od Premium]",
      values: [viewData?.totalAodPremium?.toFixed(2) || 0],
      display: "flex",
    },
  ];

  const SectionB = [
    // {
    //   label: <Box sx={{ width: "100%", height: "100%" }}></Box>,
    //   values: [inputData?.iDV],
    //   display:"flex"
    // },
    {
      label: (viewData?.formId >= 1 && viewData?.formId <= 5)
        ? policyTpCc ?? inputData?.cC
        : (viewData?.formId === 10)
          ? inputData?.gVW
          : "",
      values: ["Zone", inputData?.zone],
      display: "flex",
    },
    {
      label: "Liapility Premium(TP)",
      values: [viewData?.LP || 0],
      display: "flex",
    },
    [12].includes(selectedVehicle.id) && {
      label: "LPG KIT",
      values: [viewData?.lPGKit_B || "-"],
      display: "flex",
    },
    [5, 6, 7, 8,].includes(selectedVehicle.id) && {
      label: "LL to Passengers",
      values: [viewData?.llToPassengers || "-"],
      display:
        viewData?.formId === 5 ||
          viewData?.formId === 6 ||
          viewData?.formId === 7 ||
          viewData?.formId === 8 ||
          viewData?.formId === 9 ||
          viewData?.formId === 10
          ? "flex"
          : "none",
    },
    {
      label: "PA to Owner Driver",
      values: [viewData?.pAOwnerDriver || 0],
      display: "flex",
    },
    [1, 2, 3, 4].includes(selectedVehicle.id) && {
      label: "PA to Unnamed Passenger",
      values: [viewData?.pAUnnamedPassenger || 0],
      display: !(viewData?.formId === 6),
    },
    [1, 2, 8, 9].includes(selectedVehicle.id) && {
      label: "TPPD Restrict",
      values: [viewData?.tppd || 0],
      display:
        viewData?.formId === 1 ||
          viewData?.formId === 2 ||
          viewData?.formId === !6 ||
          viewData?.formId === 8 ||
          viewData?.formId === 9
          ? "flex"
          : "none",
    },
    [3, 4, 5, 6, 7, 8, 9, 10, 11].includes(selectedVehicle.id) && {
      label: "LL to Paid Driver",
      values: [viewData?.lLtoPaidDriver || 0],
      display: "flex",
    },
    [6, 7, 9, 10, 11].includes(selectedVehicle.id) && {
      label: "Coolies / Cleaner",
      values: [viewData?.CooliesAndCleaner || 0],
      display:
        viewData?.formId === 6 ||
          viewData?.formId === 7 ||
          viewData?.formId === 8 ||
          viewData?.formId === 9 ||
          viewData?.formId === 10
          ? "flex"
          : "none",
    },
    {
      label: "Total B [Od Premium]",
      values: [viewData?.totalBodPremium || 0],
      display: "flex",
    },
  ];

  console.log("inputs", inputs);
  console.log("SectionA", SectionA);
  console.log("SectionB", SectionB);
  console.log("insjdjsdusssdujsd", initialValues)
  return (
    <div
      className="MainRenderinContainer"
      style={{
        overflow: "auto",
        scrollbarWidth: "thin",
        scrollbarColor: "transparent transparent",
        backgroundColor: "white",
        paddingTop: "70px",
        paddingBottom: "0px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // 👈 pushes heading left & button right
          paddingRight: "18px",
          paddingBottom: "5px ",
          // optional to match left padding
        }}
      >
        <Typography
          className="Master_Header_Heading"
          sx={{
            fontFamily: "inter",
            fontSize: { xs: "14px", md: "16px", lg: "18px" },

            paddingLeft: "30px",
          }}
        >{`MotorCalculation -> ${title}`}</Typography>
        <div>
          {/* Export Button */}
          <Button
            onClick={handleOpen}
            sx={{
              backgroundColor: "#1E3A5F",
              color: "white",
              "&:hover": { backgroundColor: "#1E3A5F" },
              fontSize: "14px",
              padding: "5px 20px",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: "400",
              fontFamily: "Inter, sans-serif",
              letterSpacing: "0.5px",
            }}
          >
            <img
              src={whiteDownload}
              style={{ width: "16px", height: "16px", marginRight: "8px" }}
              alt="download"
            />
            Export
          </Button>

          {/* Dialog Popup */}
          <Dialog open={openBox} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Export Options</DialogTitle>
            <DialogContent>
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => onSubmit(values)}          >
                {() => (
                  <Form>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      {inputs
                        ?.filter((item) =>
                          ["Company", "Customer Name", "Vehicle Number", "Make Model"].includes(
                            item.placeholder
                          )
                        )
                        .map((item, index) => (
                          <Grid item xs={12} sm={6} key={index}>
                            <label
                              style={{
                                display: "block",
                                fontWeight: "400",
                                fontSize: "12px",
                                fontFamily: "Inter",
                                marginBottom: "5px",
                              }}
                            >
                              {item.placeholder}
                            </label>

                            {item.elementType === "input" ? (
                              <input
                                type="text"
                                placeholder={item.placeholder}
                                onChange={(e) =>
                                  setInputData({
                                    ...inputData,
                                    [item.placeholder.replace(/\s+/g, "")]: e.target.value,
                                  })
                                }
                                value={inputData[item.placeholder.replace(/\s+/g, "")] || ""}
                                style={{
                                  width: "100%",
                                  padding: "12px",
                                  fontSize: "12px",
                                  border: "1px solid #EAECF0",
                                  borderRadius: "8px",
                                  fontFamily: "Inter, sans-serif",
                                  color: "#667085",
                                }}
                              />
                            ) : (
                              <select
                                onChange={(e) =>
                                  setInputData({
                                    ...inputData,
                                    [item.placeholder.replace(/\s+/g, "")]: e.target.value,
                                  })
                                }
                                value={inputData[item.placeholder.replace(/\s+/g, "")] || ""}
                                style={{
                                  width: "100%",
                                  padding: "12px",
                                  fontSize: "12px",
                                  color: "#667085",
                                  border: "1px solid #EAECF0",
                                  borderRadius: "8px",
                                  fontFamily: "Inter, sans-serif",
                                }}
                              >
                                <option value="">Select {item.placeholder}</option>
                                {item.values?.map((option, idx) => (
                                  <option key={idx} value={option.id}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            )}
                          </Grid>
                        ))}
                    </Grid>

                  </Form>
                )}
              </Formik>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose} sx={{ textTransform: "none" }}>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleDownload(); // first
                  handleClose();    // then close the dialog
                }}
                sx={{
                  backgroundColor: "#1E3A5F",
                  color: "white",
                  "&:hover": { backgroundColor: "#0059CC" },
                  textTransform: "none",
                }}
              >
                Download
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>

      <div style={{ padding: "0 8px 0 26px" }}>
        {/* <Grid
          item
          sm={12}
          xs={12}
          className="Count_Page"
          sx={{ flexDirection: { xs: "column", sm: "row" } }}
          mt={2}
          gap={1}>
          <Grid className="Count_1" sx={{ width: "100%" }}>
            <Typography className="Total">
              {viewData?.netPremiumAB && viewData?.netPremiumAB !== NaN
                ? viewData?.netPremiumAB
                : 0}
            </Typography>
            <Typography className="Title">Net Premium [A + B] </Typography>
          </Grid>
          <Grid className="Count_2" sx={{ width: "100%" }}>
            <Typography className="Total">
              {viewData?.tax && viewData?.tax !== NaN ? viewData?.tax : 0}
            </Typography>
            <Typography className="Title">Gst@18%</Typography>
          </Grid>
          <Grid className="Count_2" sx={{ width: "100%" }}>
            <Typography className="Total">
              {viewData?.finalPremium && viewData?.finalPremium !== NaN
                ? viewData?.finalPremium
                : 0}{" "}
            </Typography>
            <Typography className="Title">Final Premium</Typography>
          </Grid>
        </Grid> */}
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: "20px",
            flexDirection: { xs: "column", md: "row" },
            height: { xs: "auto", md: "80vh" },
          }}
        >
          <Box
            sx={{
              display: selectedVehicle ? "block" : "none",
              width: { xs: "100%", md: "50%" },
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              padding: "20px",
              paddingBottom: "20px",
              backgroundColor: "white",
              overflowY: "auto", // ✅ makes it scrollable
              maxHeight: "80vh", // force it to take full parent's height
              boxSizing: "border-box",
              scrollbarWidth: "thin",
              scrollbarColor: "#999 #f1f1f1",

              // Webkit scrollbar for Chrome, Safari, Edge
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#999",
                borderRadius: "4px",
                "&:hover": {
                  background: "#777",
                },
              },
            }}
          >
            <Formik
              initialValues={initialValues}
              onSubmit={(values) => onSubmit(values)}
              innerRef={formRef}
            >
              {() => (
                <Form>
                  <Grid container spacing={2}>
                    {inputs ? (
                      inputs
                        .filter(
                          (item) =>
                            !["Company", "Customer Name", "Vehicle Number", "Make Model"].includes(
                              item.placeholder
                            )
                        )
                        .map((item, index) => {
                          if (
                            getItemKey(
                              item.placeholder.trim().replaceAll(" ", "")
                            ) !== "policyType" &&
                            !item.isTP &&
                            inputData.policyType === "TP"
                          ) {
                            return null;
                          }

                          return (
                            <Grid
                              item
                              xs={12}
                              sm={item.placeholder === "Policy Type" ? 12 : 6}
                              key={index}
                            >
                              <label
                                style={{
                                  display: "block",
                                  fontWeight: "400",
                                  fontSize: "12px",
                                  fontFamily: "Inter",
                                  marginBottom: "5px",
                                }}
                              >
                                {item.placeholder}
                              </label>

                              {item.elementType === "input" ? (
                                <input
                                  type="text"
                                  placeholder={item.placeholder}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9.]/g, ""); // only digits and dot
                                    setInputData({
                                      ...inputData,
                                      [getItemKey(
                                        item.placeholder.trim().replaceAll(" ", "")
                                      )]: numericValue,
                                    });
                                  }}
                                  value={
                                    inputData[
                                    getItemKey(
                                      item.placeholder
                                        .trim()
                                        .replaceAll(" ", "")
                                    )
                                    ] || ""
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "12px",
                                    fontSize: "12px",
                                    border: "1px solid #EAECF0",
                                    borderRadius: "8px",
                                    fontFamily: "Inter, sans-serif",
                                    color: "#667085",
                                  }}
                                  inputMode="numeric"
                                />
                              ) : (
                                <select
                                  onChange={(e) =>
                                    setInputData({
                                      ...inputData,
                                      [getItemKey(
                                        item.placeholder
                                          .trim()
                                          .replaceAll(" ", "")
                                      )]: e.target.value,
                                    })
                                  }
                                  value={
                                    inputData[
                                    getItemKey(
                                      item.placeholder
                                        .trim()
                                        .replaceAll(" ", "")
                                    )
                                    ]
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "12px",
                                    fontSize: "12px",
                                    color: "#667085",
                                    border: "1px solid #EAECF0",
                                    borderRadius: "8px",
                                    fontFamily: "Inter, sans-serif",
                                  }}
                                >
                                  {item.values?.map((option, idx) => (
                                    <option key={idx} value={option.id}>
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </Grid>
                          );
                        })
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "40px",
                        }}
                      >
                        Loading the data ...
                      </p>
                    )}
                  </Grid>
                </Form>
              )}
            </Formik>
          </Box>

          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              borderRadius: 0,
              backgroundColor: "white",
              maxHeight: "100%",
              // overflow: "hidden",
              padding: "10px",
              paddingTop: "0px",

              // overflow: "hidden",
            }}
          >
            {/* One CC box, two vehicles: say which CC the right-hand column used. */}
            {policyTpCc !== null && (
              <Typography sx={{ fontSize: 12, color: "#667085", padding: "0 4px 6px" }}>
                Third party priced on the TP vehicle: {policyTpCc} CC
              </Typography>
            )}
            <Grid sx={BoxStyle}>
              <Grid
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  borderRight: { xs: "none", md: "1px solid #EAECF0" },
                  borderBottom: { xs: "1px solid #EAECF0", md: "none" },
                  paddingRight: { xs: 0, md: "10px" },
                  paddingBottom: { xs: "10px", md: 0 },
                }}
              >
                {SectionA.filter(Boolean).map((e, elKey) => (
                  <Grid
                    className="Calculations_Box"
                    sx={{
                      display: e.display,
                      borderBottom: "1px solid #EAECF0",
                      display: "flex",
                      justifyContent: "space-between",
                      padding: selectedVehicle?.id === 8 || selectedVehicle?.id === 5 || selectedVehicle?.id === 6 || selectedVehicle?.id === 7 || selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11 ? "1px" : "5px"
                    }}
                    key={elKey}
                  >
                    <Typography className="Box_Label">{e?.label}</Typography>
                    {Array.isArray(e.values) && e.values.length > 1 ? (
                      <Box sx={{ display: "flex", }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#333" }}>
                          {typeof e.values[0] === "number"
                            ? e.values[0].toFixed(3)
                            : e.values[0] ?? 0}
                        </Typography>
                        <Typography sx={{ marginLeft: 10, fontSize: 14, fontWeight: 500, color: "#333" }}>
                          {typeof e.values[1] === "number"
                            ? e.values[1].toFixed(2)
                            : e.values[1] ?? 0}
                        </Typography>
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", gap: 5 }}>
                        <Typography sx={{ display: "block", fontSize: 14, fontWeight: 500, color: "#333" }}>
                          {typeof e.values?.[0] === "number"
                            ? e.values[0].toFixed(2)
                            : e.values?.[0] ?? 0}
                        </Typography>
                      </Box>

                    )}
                  </Grid>
                ))}

              </Grid>

              <Grid
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  paddingLeft: { xs: 0, md: "10px" },
                  paddingTop: { xs: "10px", md: 0 },
                }}
              >
                {SectionB.filter(Boolean).map((e, _i) => (
                  <Grid
                    className="Calculations_Box"
                    sx={{
                      display: e.display,
                      borderBottom: "1px solid #EAECF0",
                      justifyContent: "space-between",
                      padding: selectedVehicle?.id === 8 || selectedVehicle?.id === 5 || selectedVehicle?.id === 6 || selectedVehicle?.id === 7 || selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11 ? "1px" : "5px"
                    }}
                    key={_i}
                  >
                    <Typography className="Box_Label">{e?.label}</Typography>
                    {Array.isArray(e.values) && e.values.length > 1 ? (
                      <>
                        <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#333" }}>
                          {typeof e.values[0] === "number"
                            ? e.values[0].toFixed(2)
                            : e.values[0] ?? 0}
                        </Typography>
                        <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#333" }}>
                          {typeof e.values[1] === "number"
                            ? e.values[1].toFixed(2)
                            : e.values[1] ?? 0}
                        </Typography>
                      </>
                    ) : (
                      <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#333" }}>
                        {typeof e.values?.[0] === "number"
                          ? e.values[0].toFixed(2)
                          : e.values?.[0] ?? 0}
                      </Typography>
                    )}
                  </Grid>
                ))}

              </Grid>
            </Grid>
            <Grid container sx={BoxStyle1}>
              <Grid item xs={6}>
                <Stack
                  direction={"row"}
                  sx={{
                    justifyContent: "space-between",
                    padding: "5px",
                    // marginTop: "11px",
                  }}
                >
                  <Typography sx={rowStyleLabel}>
                    Net Premium [A + B]
                  </Typography>
                </Stack>
                <Divider />
                <Stack
                  direction={"row"}
                  sx={{
                    justifyContent: "space-between",
                    padding: "5px",
                  }}
                >
                  <Typography sx={rowStyleLabel}>Gst@18% [A + B]</Typography>
                </Stack>
                <Divider />
                {(selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11) && (
                  <Stack
                    direction="row"
                    sx={{
                      justifyContent: "space-between",
                      padding: "5px",
                    }}
                  >
                    <Typography sx={rowStyleLabel}>GST On TP 5%</Typography>
                  </Stack>
                )}
                <Divider />
                <Stack
                  direction={"row"}
                  sx={{
                    justifyContent: "space-between",
                    padding:
                      selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11
                        ? "0px"
                        : "12px",
                    paddingBottom:
                      selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11
                        ? "0"
                        : "12px",
                  }}
                >
                  <Typography sx={rowStyleLabel1}>Final Premium </Typography>
                </Stack>
              </Grid>
              <Divider orientation="vertical" flexItem />

              <Grid item xs={5.9} sx={{ alignSelf: "end" }}>
                <Stack
                  direction={"row"}
                  sx={{
                    justifyContent: "center",
                    padding: "5px",
                  }}
                >
                  <Typography sx={rowStyleValue}>
                    {formatTwo(viewData?.netPremiumAB)}
                  </Typography>
                </Stack>
                <Divider />
                <Stack
                  direction={"row"}
                  sx={{
                    justifyContent: "center",
                    padding: "5px",
                  }}
                >
                  <Typography sx={rowStyleValue}>
                    {formatTwo(
                      (selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11)
                        ? viewData?.tax18
                        : viewData?.tax
                    )}
                  </Typography>
                </Stack>
                <Divider />
                {(selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11) && (
                  <Stack
                    direction="row"
                    sx={{
                      justifyContent: "center",
                      padding: "5px",
                    }}
                  >
                    <Typography sx={rowStyleValue}>
                      {formatTwo(viewData?.tax12)}
                    </Typography>
                  </Stack>
                )}

                <Divider />
                <Stack
                  direction={"row"}
                  sx={{
                    justifyContent: "center",
                    padding:
                      selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11
                        ? "0px"
                        : "12px",
                    paddingBottom:
                      selectedVehicle?.id === 9 || selectedVehicle?.id === 10 || selectedVehicle?.id === 11
                        ? "0"
                        : "12px",
                  }}
                >
                  <Typography sx={rowStyleValue1}>
                    {formatTwo(viewData?.finalPremium)}
                  </Typography>
                </Stack>
              </Grid>

              {/* <Stack direction={"row"} sx={{ justifyContent: "space-between", padding:"0px 0px 10px 0px" } }>
                <Typography sx={rowStyleLabel}>Net Premium [A + B]</Typography>
                <Typography sx={rowStyleValue}>{viewData?.netPremiumAB || 0}</Typography>
              </Stack>
              <Divider />
              <Stack direction={"row"} sx={{ justifyContent: "space-between" ,padding:"10px 0px"}}>
                <Typography sx={rowStyleLabel}>Gst@18%</Typography>
                <Typography sx={rowStyleValue}>{viewData?.tax || 0}</Typography>
              </Stack>
              <Divider />
              <Stack direction={"row"} sx={{ justifyContent: "space-between" ,padding:"10px 0px" }}>
                <Typography sx={rowStyleLabel}>Final Premium</Typography>
                <Typography sx={rowStyleValue}>{viewData?.finalPremium || 0}</Typography>
              </Stack> */}
            </Grid>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default Calculations;
